import { AnimationControls, motion } from 'framer-motion'

const fadePageTransition = {
  initial: { opacity: 0, display: 'none' },
  in: { opacity: 1, display: 'flex' },
  out: { opacity: 0, display: 'none' },
}
const bottomInPageTransition = {
  initial: { y: '100%', opacity: 0, invisible: 'hidden' },
  in: { y: 0, opacity: 1, invisible: 'unset' },
  out: { y: '100%', opacity: 0, invisible: 'hidden' },
}

const bottomOutPageTransition = {
  initial: { y: '100%' },
  in: { y: 0 },
  out: { y: '100%' },
}

const hotDealChipsTransition = {
  initial: { opacity: 0.3 },
  in: { opacity: 1 },
  out: { opacity: 0.3 },
}

export const durationFadeTransitionProps = {
  initial: 'initial',
  animate: 'in',
  exit: 'out',
  transition: {
    duration: 0.3,
    repeat: Infinity,
    repeatDelay: 0.15,
    ease: 'linear',
    repeatType: 'reverse',
  },
  variants: hotDealChipsTransition,
  as: motion.span,
}

export const fadeTransitionProps = {
  initial: 'initial',
  animate: 'in',
  exit: 'out',
  transition: { duration: 0.5 },
  variants: fadePageTransition,
  as: motion.div,
}

export const bottomInPageTransitionProps = {
  initial: 'initial',
  animate: 'in',
  exit: 'out',
  transition: { duration: 0.4, type: 'tween' },
  variants: bottomInPageTransition,
  as: motion.div,
}

export const bottomOutPageTransitionProps = {
  initial: 'initial',
  animate: 'in',
  exit: 'out',
  variants: bottomOutPageTransition,
  as: motion.div,
}

export const handleCouponMapBottomSheetAnimation = (control: AnimationControls) => ({
  initial: { y: '100%', x: '0%', opacity: 0, scale: 1, display: 'none' },
  open: () => {
    control?.start({
      y: 0,
      x: 0,
      opacity: 1,
      scale: 1,
      display: 'flex',
      transition: { duration: 0.5 },
    })
  },
  close: () => {
    control?.start({
      y: '100%',
      x: '0%',
      opacity: 0,
      scale: 1,
      transition: { duration: 0.5 },
      transitionEnd: { display: 'none' },
    })
  },
})
